import { useI18n } from "../../utils/translate/i18n/useI18n";
import type { HeadphoneConnection, HeadphoneType } from "../../type/demographics";
import "./headphoneTypeSelector.scss";

type Props = {
  headphoneType: HeadphoneType;
  headphoneConnection: HeadphoneConnection;
  onChangeHeadphoneType: (value: HeadphoneType) => void;
  onChangeHeadphoneConnection: (value: HeadphoneConnection) => void;
};

export default function HeadphoneTypeSelector({
  headphoneType,
  headphoneConnection,
  onChangeHeadphoneType,
  onChangeHeadphoneConnection,
}: Props) {
  const { t } = useI18n();

  const typeCards: { value: Extract<HeadphoneType, "in-ear" | "over-ear">; icon: string; label: string }[] = [
    { value: "in-ear", icon: "bi-earbuds", label: t("Douszne") },
    { value: "over-ear", icon: "bi-headphones", label: t("Nauszne") },
  ];

  const connectionCards: { value: Extract<HeadphoneConnection, "wired" | "wireless">; icon: string; label: string }[] = [
    { value: "wired", icon: "bi-plug-fill", label: t("Przewodowe") },
    { value: "wireless", icon: "bi-bluetooth", label: t("Bezprzewodowe") },
  ];

  return (
    <div className="styled-select-row styled-select-row--on-dark headphone-picker-row">
      <div className="styled-select-row-icon">
        <i className="bi bi-headphones" />
      </div>

      <div className="styled-select-row-label">{t("Używasz słuchawek")}</div>

      <div className="headphone-picker">
        {typeCards.map(card => (
          <button
            key={card.value}
            type="button"
            className={`headphone-picker__card${headphoneType === card.value ? " headphone-picker__card--active" : ""}`}
            onClick={() => onChangeHeadphoneType(headphoneType === card.value ? "unspecified" : card.value)}
            aria-pressed={headphoneType === card.value}
          >
            <i className={`bi ${card.icon}`} aria-hidden="true" />
            <span>{card.label}</span>
          </button>
        ))}

        {headphoneType === "over-ear" && (
          <>
            <span className="headphone-picker__divider" aria-hidden="true" />
            {connectionCards.map(card => (
              <button
                key={card.value}
                type="button"
                className={`headphone-picker__card headphone-picker__card--small${headphoneConnection === card.value ? " headphone-picker__card--active" : ""}`}
                onClick={() => onChangeHeadphoneConnection(headphoneConnection === card.value ? "unspecified" : card.value)}
                aria-pressed={headphoneConnection === card.value}
              >
                <i className={`bi ${card.icon}`} aria-hidden="true" />
                <span>{card.label}</span>
              </button>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
